module.exports = __webpack_public_path__ + "static/media/filter-p.83cd4ac3.svg";